import React , { useRef , useState  } from 'react'

import { Row , Col, Form} from 'react-bootstrap'


import Select from 'react-select'

import {ApiCallGet}  from '../Components/ApiCall/ApiCall'

//import axios from 'axios'

export default function Productos() {

    const [theOptions,setTheOptions] = useState([])

    const skuRef = useRef()
    const skuRef2 = useRef() ;


    const options = [

      ]


    function OnSkuChanged() {
        console.log("sku clicked " + skuRef.current.value)


        var value = skuRef.current.value ;
        if ( value.length > 3 )
        {
            //setTheOptions( options )

            getProductos( value ) // Solicitamos los productos que empaten
        }
        else{
            setTheOptions( [] )

            skuRef2.current.label = "" ;   
        }
        
    }

    function OnSkuChanged2() {

        var value = skuRef.current.value ;

        console.log( "Value2 = " + value )

        if ( value.length > 3 )
        {
            setTheOptions( options )
        }


    }

    function getProductos(sku) // JHW35277-TH
    {
        ApiCallGet("productos/?sku=" + sku)
        .then((response) => {

            console.log( JSON.stringify( response ) )

            var theArray = []


            for( var i = 0 ; i < response.length ; i++ )
            {
                var obj = {
                    value : "" ,
                    label : ""
                }

                obj.value = response[i].sku.toString() ;
                obj.label = response[i].sku.toString() + " => " + response[i].descripcion ;
                obj.almacen1 = response[i].almacen1 ;
                obj.almacen2 = response[i].almacen2 ;
                obj.precio = response[i].precio ;
                obj.costo = response[i].costo ;

                theArray.push( obj ) ;
            }

            setTheOptions( theArray ) ;

        })
        .catch((err) => {
            console.log( err ) ;
        })
    }

    return (
        <div className='d-flex flex-column justify-content-center box-1 backemployer-2 centersearch'>

    
    
                <div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2'  id="page1">
    
                    <Row>
                        <Col className='col-8'>
                            <h4>Producto</h4>
                        </Col>
                    </Row>
    
    
    
    
    
                    <form className='pt-1'  style={{width:'90h'}}  >


    
                        <div className='row'>
    
                            <div className='col-sm-6'>
                                <div className="form-group"  style={{width: "100%"  }} >
                                    <label className="form-label m-0" htmlFor="codigo">Sku</label>
                                    <input type="text" className="form-group p-lg-2" id="sku"  
                                    placeholder="Sku"  onChange= { (val)=> OnSkuChanged(val)}
                                    ref={skuRef}
                                    />
                                    
                                </div>
                            </div>
                            <div className='col-sm-6' style={{paddingTop:'34px'}}>
                                <Select ref={skuRef2} options={theOptions}  >
                                    
                                </Select>
                            </div>
    
    
                        </div>
    
    

    
    
    
    
                        <div className='row'>
    
    
                            <div className='col-sm-6'>
                                <div className="form-group"  style={{width: "100%"  }} >
                                    <label className="form-label m-0" htmlFor="almacen1">Almacen 1</label>
                                    <input type="number" className="form-group p-lg-2" id="almacen1"  disabled
                                    placeholder="Almacen 1"  
                                    />
                                    
                                </div>
                            </div>
    
    
                            <div className='col-sm-6'>
                                <div className="form-group"  style={{width: "100%"  }} >
                                    <label className="form-label m-0" htmlFor="almacen2">Almacen2</label>
                                    <input type="number" className="form-group p-lg-2" id="almacen2"  
                                    placeholder="almacen2"  disabled
                                    />
                                    
                                </div>
                            </div>
    
    
    
                        </div>
    
    
                        <div className='row'>
    
    
                            <div className='col-sm-6'>
                                <div className="form-group"  style={{width: "100%"  }} >
                                    <label className="form-label m-0" htmlFor="precio">Precio</label>
                                    <input type="number" className="form-group p-lg-2" id="precio"  
                                    placeholder="Precio"  
                                    />
                                    
                                </div>
                            </div>
    
    
                            <div className='col-sm-6'>
                                <div className="form-group"  style={{width: "100%"  }} >
                                    <label className="form-label m-0" htmlFor="costo">Costo</label>
                                    <input type="number" className="form-group p-lg-2" id="costo"  
                                    placeholder="costo" disabled
                                    />
                                    
                                </div>
                            </div>
    
    
    
                        </div>



                        <div className='row'>     
                            
                            <div className='col'>

                            
                                <div className="form-group"  >
                                    <label className="m-0" htmlFor="descripcion">Observaciones</label>
                                    <textarea type="textarea" className="form-control" id="observaciones"  
                                    placeholder="Observaciones"  maxLength={120} size= {100} rows={2}
                                    />
                                    
                                </div>
                            </div>

                        </div>
    
    
    
    
                        <div className='col-sm-4'>
                            <button type="submit"  className="btn btn-primary mt-3 button-3"  >Aceptar</button> 
                        </div>
    

    
                        
    
    
    
                    </form> 
    
    
        </div>
        </div>
    
      )
    
}
